import React from 'react';
import './App.css';
import { QuickSortHomeWrapper } from './components/home/QuickSortHomeWrapper';

// import { Home } from './components/home/Home';

function App() {
  return (
    <QuickSortHomeWrapper />
  );
}

export default App;
